import { Injectable } from '@angular/core';

import {Project} from '../../models/project';

@Injectable()
export class ProjectsService {

  /*private testProjects: Project[] = [
    {
      name: 'project 1',
      description: 'this is description',
      link: 'this will be the link',
      technology: 'web',
      icon: 'ion-social-nodejs',
    },
    {
      name: 'project 2',
      description: 'this is description',
      link: 'this will be the link',
      technology: 'mobile',
      icon: 'ion-android-phone-portrait',
    },
    {
      name: 'project 3',
      description: 'this is description',
      link: 'this will be the link',
      technology: 'mobile',
      icon: 'ion-social-javascript',
    },
  ];*/

  constructor() { }

  getProjects() {
    // return this.testProjects;
  }

}



// WEBPACK FOOTER //
// F:/Home/Locker/About-me/about-me1/src/app/displayer/projects/projects.service.ts